import { render, staticRenderFns } from "./OnboardingModal.vue?vue&type=template&id=6433946e&scoped=true"
import script from "./OnboardingModal.vue?vue&type=script&lang=js"
export * from "./OnboardingModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingModal.vue?vue&type=style&index=0&id=6433946e&prod&scoped=true&lang=css"
import style1 from "./OnboardingModal.vue?vue&type=style&index=1&id=6433946e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6433946e",
  null
  
)

export default component.exports